import { useEffect, useRef, useState } from "react";
import { animate, useInView, useReducedMotion } from "framer-motion";
import { useLanguage } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/Reveal";

const Counter = ({ to, suffix = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const reduce = useReducedMotion();
  const [val, setVal] = useState(reduce ? to : 0);
  useEffect(() => {
    if (!inView || reduce) return;
    const controls = animate(0, to, { duration: 1.6, ease: "easeOut", onUpdate: (v) => setVal(Math.round(v)) });
    return () => controls.stop();
  }, [inView, to, reduce]);
  return <span ref={ref}>{val}{suffix}</span>;
};

const Stat = ({ value, label, testid }) => (
  <div data-testid={testid}>
    <p className="font-display text-4xl text-gold md:text-5xl">{value}</p>
    <p className="mt-3 text-xs font-bold uppercase tracking-[0.2em] text-white/55">{label}</p>
  </div>
);

export const TrustStats = () => {
  const { t } = useLanguage();
  return (
    <section className="bg-charcoal py-20 md:py-24" data-testid="trust-stats">
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-x-6 gap-y-12 px-5 md:px-8 lg:grid-cols-4">
        <Reveal><Stat testid="stat-years" value={<Counter to={10} suffix="+" />} label={t("stats.years")} /></Reveal>
        <Reveal delay={0.08}><Stat testid="stat-projects" value={<Counter to={50} suffix="+" />} label={t("stats.projects")} /></Reveal>
        <Reveal delay={0.16}><Stat testid="stat-capability" value="G – G+6" label={t("stats.capability")} /></Reveal>
        <Reveal delay={0.24}><Stat testid="stat-coverage" value={<span className="text-3xl md:text-4xl">Tumakuru + Bengaluru</span>} label={t("stats.coverage")} /></Reveal>
      </div>
    </section>
  );
};
